import { type PrintPreferences } from '../types/preferences.type';
import { type PrintInitiation } from '../types/print.type';

export const getPrinterNamesForInitiation = (
  preferences: PrintPreferences,
  initiation: PrintInitiation,
) => {
  const printerNames = new Set<string>();
  for (const pref of Object.values(preferences)) {
    if (pref.initiation !== initiation || !pref.printerName) continue;
    printerNames.add(pref.printerName);
  }

  return [...printerNames].sort();
};
